import i18n from 'utils/i18n'
import { getFileExtension } from 'utils/uploadFile'
import { AVAILABLE_EXTENSIONS } from 'utils/consts/images'

const MAX_IMG_SIZE_MB = 20
const MAX_IMG_SIZE = MAX_IMG_SIZE_MB * 1024 * 1024

export const validateFile = (file: File): string | null => {
  const extension = getFileExtension(file.name)
  const size = file.size

  if (!AVAILABLE_EXTENSIONS.includes(extension)) {
    return i18n.t('image.create.errors.format')
  }

  if (size > MAX_IMG_SIZE) {
    return i18n.t('image.create.errors.size', { n: MAX_IMG_SIZE_MB })
  }

  return null
}
